
import Header from '../../component/Header'
import Programs from '../../component/Programs'
import Vals from '../../component/Vals'

import './home.css'


const Home = () => {
  return (
    <>
    <Header/>
    <Programs/>
    <Vals/>
    
    
    </>
  )
}

export default Home